import React, { Component, FC, ReactNode, useContext } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultPresentationComponent } from "./DefaultPresentationComponent";
import { i18nContext } from "../model/I18n";
import { FieldState } from "final-form";

export type TypeComponentType =
  | Component<FieldRenderProps<any>>
  | FC<FieldRenderProps<any>>
  | string;

export type Error = string | ReactNode;
export type Validator = (
  value: any,
  allValues: any,
  meta: FieldState<any>
) => Promise<Error | undefined>;

export interface TypeConfig {
  Component: TypeComponentType;
  PresentationComponent?: TypeComponentType;
  validators?: Validator[];
  props?: {};
}

export class Type {
  public Component: TypeComponentType;
  public PresentationComponent: TypeComponentType;
  public validators: Validator[];
  public props?: {};

  public constructor(config: TypeConfig) {
    this.Component = config.Component;
    this.PresentationComponent =
      config.PresentationComponent || DefaultPresentationComponent;
    this.validators = config.validators || [];
    this.valid = this.composeValidators(this.validators);
    this.props = config.props;
  }

  public async valid(
    v: any,
    allValues: any,
    meta: FieldState<any>
  ): Promise<Error | undefined> {
    return;
  }

  private composeValidators(validators: Validator[]): Validator {
    return async (v: any, allValues: any, meta: FieldState<any>) => {
      for (const validator of validators) {
        try {
          await validator(v, allValues, meta);
        } catch (e) {
          return <Err error={e} />;
        }
      }

      return;
    };
  }
}

const Err = (props: any) => {
  const i18n = useContext(i18nContext);
  const { error } = props;

  const msg = error.key
    ? i18n.t(error.key, error.message, error.args)
    : error.message;

  return <>{msg}</>;
};
